<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h4 style="padding-bottom: 20px">Ваш код из набора</h4>
            <div class="row">
                <div class="col-sm-6 mb-2">
                    <div class="input-group">
                        <span class="input-group-text" id="codeInput">Ваш код</span>
                        <input v-model="qr_code" disabled type="text" class="form-control"
                               placeholder="Код из набора"
                               aria-label="Код из набора" aria-describedby="codeInput">
                        <div id="codeInputFeedback" class="invalid-feedback text-end">
                            Не верный код, попробуйте еще раз.
                        </div>
                    </div>
                </div>
                <div class="d-grid gap-2  col-sm-6 mb-2 mx-auto">
                    <button @click="copy_qr" class="btn btn-outline-secondary" type="button">
                        Скопировать код
                    </button>

                </div>
            </div>
            <div class="alert alert-info text-center" role="alert" v-show="show_copy_alert">
                Код скопирован!
            </div>

            <div v-if="res_check == 'ok'" class="d-grid gap-2" style="padding-bottom: 20px; padding-top: 10px;">
                <button class="btn btn-primary" type="button"
                        @click="this.$router.push(`/generation/` + this.qr_code)">Перейти к генерации картины
                </button>
            </div>
            <div v-else-if="res_check == 'pdf'" class="d-grid gap-2" style="padding-bottom: 20px;">
                <button class="btn btn-primary" type="button"
                        @click="this.$router.push(`/instruction/` + this.qr_code)">Открыть инструкцию к вашей картине
                </button>
            </div>
            <div v-else class="d-grid gap-2" style="padding-bottom: 20px;">
                    <span class="text-danger">
                        Указанный код не найден. Попробуйте снова сканировать QR-код на обратной стороне вашего холста из набора.
                        Если ошибка повторится, напишите в поддержку, мы постараемся вам помочь.
                    </span>
            </div>


            <div style="padding: 20px 5px 20px 5px;">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Немного информации
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <h4>Поздравляем вас с приобретением нашего набора.</h4>
                                Прямо сейчас вы можете подобрать картину которую вы будите рисовать. Вы можете
                                подбирать картину столько раз, сколько вам понадобится. Только когда вы определитесь с
                                выбором, вы можете активировать код и получить инструкцию. Инструкцию можно скачать и
                                распечатать или вы всегда сможете открыть ее прямо в браузере, для этого все так же
                                перейдите по qr-code в наборе или введите код на странице генерации.
                                Скорее переходите к генерации картины и начинайте рисовать.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Вы хотите подобрать картину на другом устройстве ?
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Скопируйте код и вводите его на другом устройстве для того чтобы подобрать картину и
                                получить инструкцию. Главное не делитесь кодом в сети интернет до его активации, и если
                                не хотите показывать свою картину другим, сохраните его в тайне.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pl" v-if="show_spinner">
                <grid-loader class="sp" :loading="true" color="blue"></grid-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import GridLoader from 'vue-spinner/src/GridLoader.vue';
    import {Tooltip} from "bootstrap/dist/js/bootstrap.esm.min.js";

    export default {
        name: "CodeN",
        components: {
            GridLoader
        },
        data() {
            return {
                qr_code: null,
                show_spinner: false,
                res_check: null,
                show_copy_alert: false,
            }
        },
        methods: {
            async check_code() {
                try {
                    this.qr_code = this.$route.query.c;
                    this.show_spinner = true;
                    const response = await
                        this.$axios.post('/qr_code_check',
                            {
                                qr_code: this.qr_code,
                            });

                    this.res_check = response.data.res_check;
                    this.show_spinner = false;
                } catch (e) {
                    console.log(e);
                    this.show_spinner = false;
                }
            },
            copy_qr() {
                window.navigator.clipboard.writeText(this.qr_code);
                this.show_copy_alert = true;
                setTimeout(() => {
                    this.show_copy_alert = false;
                }, 2000);
            }

        },
        created() {
            this.check_code();
        },
        mounted() {
            new Tooltip(document.body, {
                selector: "[data-bs-toggle='tooltip']",
            })
        },
    }
</script>

<style scoped>

</style>